module.exports = __webpack_public_path__ + "static/media/img3.b237e127.jpg";